<template>
    <div class="border rounded">
        <h5 class="text-muted px-1 pt-1">Meslek Kodları</h5>
        <b-modal id="create" title="SGK Meslek Kodu Değişimi" no-close-on-esc no-close-on-backdrop>
            <employee-occupation-title-create v-model="request"></employee-occupation-title-create>
            <template #modal-footer><v-executer :loading="loading" text="Kaydet" :action="create"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="addNew"
                    :items-provider="provider"
                    :settings="false"
                    :fields="fields"></v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import EmployeeOccupationTitleCreate from './EmployeeOccupationTitleCreate.vue'

export default {
    components:{
        EmployeeOccupationTitleCreate
    },
    props:{
        id:[String,Number],
    },
    data(){
        return {
            fields:[
                {name:'SGK Meslek Kodu',key:'SGKOccupationCode',thClass:'w-20'},
                {name:'SGK Meslek Adı',key:'OccupationTitleName',thClass:'w-60'},
                {name:'Tarih',key:'Date',thClass:'w-20'},
            ],
            loading:false,
            request:{
                EmployeeId:null,
                OccupationTitleId:null,
                Date:null
            }
        }
    },
    methods:{
        provider(){
            return EmployeeOperationsApi.OccupationTitle.List(this.id)
        },
        clearForm(){
            this.request.EmployeeId = null
            this.request.OccupationTitleId = null
            this.request.Date = null
        },
        addNew(){
            this.clearForm()
            this.$showModal('create')
        },
        create(){
            this.loading = true
            EmployeeOperationsApi.OccupationTitle.Create({
                EmployeeId:this.id,
                OccupationTitleId:this.request.OccupationTitleId,
                Date:this.request.Date
            }).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>